// extracted by mini-css-extract-plugin
export default {"vertical":"form-input-group_vertical__3xbSg","horizontal":"form-input-group_horizontal__HXcXU"};